module.exports = __webpack_public_path__ + "img/logo.5296871e.png";